<cap-content-header>
  <cap-title>
    {{ "ech0134.grundbuchmeldung.list" | translate }}
  </cap-title>
</cap-content-header>
<div>
  <cap-ech0134-grundbuchmeldung-table
    [listLoader]="listLoader"
    [showTagebuch]="true"
    [tableSortModel]="tableSortModel"></cap-ech0134-grundbuchmeldung-table>
</div>
